import { FirebaseError } from 'firebase/app';

export function isFirebaseError(err: any): err is FirebaseError {
  return 'code' in err && 'name' in err;
}
